<template><header class="xp-client-heading"><div><div class="xp-client-eyebrow">XPROJECT · 工作空间</div><h1>{{ title }}</h1><p>{{ description }}</p></div><slot /></header></template>
<script>export default { name: 'ClientPageHeading', props: { title: String, description: String } };</script>
